export const PROJECT_EXECUTION_PHASE = {
  INITIATE: 'urn:replicon-psa:project-stage:initiate',
  PLANNING: 'urn:replicon-psa:project-stage:planning',
  EXECUTION: 'urn:replicon-psa:project-stage:execution',
  CLOSEOUT: 'urn:replicon-psa:project-stage:close-out',
  ARCHIVED: 'urn:replicon-psa:project-stage:archived'
};
